import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { selectUsers } from "../state/reducers/userSlice";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import patientService from "../services/patient-service";
import facilityService from "../services/facility-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Modal } from "react-responsive-modal";
import moment from "moment";

const tablePropsInit = {
  columns: [
    { key: "select", title: "Select", style: { width: "100px" } },
    { key: "fname", title: "Name" },
    { key: "acct_number", title: "Account number" },
    { key: "dob", title: "Date of Birth" },
    { key: "gender", title: "Gender" },
    { key: "fac_dcode", title: "Facility" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
  enabled: false
},

};

const PatientList = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [releaseOpen, setReleaseOpen] = useState(false);
  const { user } = useSelector(selectUsers);
  const [access, setAccess] = useState({});
  const onReleaseCloseModal = () => {
    setReleaseOpen(false);
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          <Link to={`patient/${rowData.id}`}>
            <img src="/img/edit_icon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
      </div>
    );
  };
  const [searchText, setSearchText] = useState("");

const [nextUrl, setNextUrl] = useState(null);
const [isFetchingMore, setIsFetchingMore] = useState(false);

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [patientList, setPatientList] = useState([]);
  const dispatch = async (action) => {
  changeTableProps((prev) => kaReducer(prev, action));

  if (action.type === ActionType.LoadData) {
    setLoading(true);

   
    const resp = await patientService.getPatients(
      tableProps.searchText || "",
      tableProps.paging.pageSize
    );
    const list = Array.isArray(resp?.list) ? resp.list : [];

    const pList = list.map((item) => ({
      ...item,  
      fname: `${item.lname}, ${item.fname}`,
      dob: moment.utc(item.dob).format("YYYY-MM-DD"),
      selected: false,
    }));

    changeTableProps((prev) =>
      kaReducer(prev, updateData(pList))
    );

    setPatientList(pList);
    setNextUrl(resp.nextUrl || null)
    setLoading(false);
  }
};

const loadMorePatients = async () => {
  if (!nextUrl || isFetchingMore) return;

  setIsFetchingMore(true);

  const paddedSearch = searchText.trim();

  const resp = await patientService.getPatients(paddedSearch, 20, nextUrl);

  const list = Array.isArray(resp?.list) ? resp.list : [];

  const newPatients = list.map((item) => ({
    ...item,
    fname: `${item.lname}, ${item.fname}`,
    dob: moment.utc(item.dob).format("YYYY-MM-DD"),
    selected: false,
  }));

  const merged = [...patientList, ...newPatients];

  setPatientList(merged);
  setNextUrl(resp.nextUrl || null);

  changeTableProps((prev) =>
    kaReducer(prev, updateData(merged))
  );

  setIsFetchingMore(false);
};

const fetchPatientsBySearch = async (value) => {
  setLoading(true);
  setNextUrl(null);
  setPatientList([]);

  const searchValue = value.trim();

  const resp = await patientService.getPatients(searchValue, 20);

  const list = Array.isArray(resp?.list) ? resp.list : [];

  const pList = list.map((item) => ({
    ...item,
    fname: `${item.lname}, ${item.fname}`,
    dob: moment.utc(item.dob).format("YYYY-MM-DD"),
    selected: false,
  }));

  setPatientList(pList);
  setNextUrl(resp.nextUrl || null);

  changeTableProps((prev) =>
    kaReducer(prev, updateData(pList))
  );

  setLoading(false);
};


  const CustomCellNewCheckbox = ({ rowData }) => {
    return (
      <div key={rowData.rowData.id}>
        <input
          type="checkbox"
          id={rowData.rowData.id}
          checked={rowData.rowData["selected"]}
          onChange={(e) => {
            const selectedItem = patientList.findIndex(
              (item) => item.id === rowData.rowData.id
            );
            patientList[selectedItem]["selected"] = e.target.checked;
            dispatch(updateData(patientList));
          }}
        />
      </div>
    );
  };

  const handleRelease = async () => {
    try {
      var items = patientList.filter((item) => item["selected"] === true);
      if (items.length !== 0) {
        setLoading(true);
        var list = items?.map((item) => item.id);
        await patientService.releasePatients(list);
        let resp = await patientService.getPatients(searchText);
        let respList = resp.list;
        respList.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        let pList = respList?.map((item) => {
          item.fname = item.lname + ", " + item.fname;
          item.dob = moment(item.dob).format("YYYY-MM-DD");
          return item;
        });
        setLoading(false);
        setPatientList(pList);
        setNextUrl(resp.nextUrl || null);
        dispatch(updateData(pList));
      } else {
        const { hide } = cogoToast.error("No patients selected", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        return;
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error processing request. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const getMessage = function () {
    let count = patientList.filter((item) => item["selected"] === true)?.length;
    return (
      "Are you sure you want to release " +
      count +
      `${count === 1 ? " patient?" : " patients?"}`
    );
  };

  const getAccessForFacility = async () => {
    try {
      let resp = await facilityService.getAccessForFacilities(user?.facility);
      setAccess(resp);

      const tablePropsInitAccess = {
        columns: [
          { key: "select", title: "Select", style: { width: "100px" } },
          { key: "fname", title: "Name" },
          { key: "acct_number", title: "Account number" },
          { key: "dob", title: "Date of Birth" },
          { key: "gender", title: "Gender" },
          { key: "fac_dcode", title: "Facility" },
          {
            key: "Actions",
            title: "Actions",
            visible: resp?.add_patient === "T",
          },
        ],
        singleAction: loadData(),
        sortingMode: SortingMode.Single,
        rowKeyField: "id",
        search: ({ searchText, rowData, column }) => {
          if (column.key === "passed") {
            return (
              (searchText === "false" && !rowData.passed) ||
              (searchText === "true" && rowData.passed)
            );
          }
        },
        paging: {
  enabled: false,
},

      };
      changeTableProps(tablePropsInitAccess);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  useEffect(() => {
    getAccessForFacility();
  }, [user]);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={releaseOpen} onClose={onReleaseCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            {getMessage()}
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                handleRelease();
                setReleaseOpen(false);
              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>
            <button
              onClick={() => {
                setReleaseOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">PATIENTS</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
               onChange={(e) => {
  const value = e.currentTarget.value;
  setSearchText(value);
  fetchPatientsBySearch(value);
}}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mb--3 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className={`absolute w-4 h-4  right-5 ${access?.add_patient === "T"  ? "bottom-1" :   "bottom-5"} `}
              ></img>
            </span>

            {access?.add_patient === "T" && (
              <span className="mr-3">
                <Link
                  to="/createPatient"
                  className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                >
                  ADD PATIENT
                </Link>
              </span>
            )}
            {access?.release_patient === "T" && (
              <span className="mr-4">
                <button
                  className={
                    patientList?.length === 0
                      ? "opacity-50 cursor-not-allowed  bg-rose  rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6 "
                      : "bg-rose  rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                  }
                  aria-label="Release"
                  onClick={() => setReleaseOpen(true)}
                >
                  RELEASE
                </button>
              </span>
            )}
          </div>
        </div>
       <div
  className="p-2 text-xs usersList gridList no-scrollbar"
  style={{
    height: "500px",
    overflowY: "auto"
  }}
  onScroll={(e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 50) {
      loadMorePatients();
    }
  }}
>

  <Table
    {...tableProps}
    childComponents={{
      cellText: {
        content: (props) => {
          switch (props.column.key) {
            case "select":
              return <CustomCellNewCheckbox rowData={props} />;
            case "Actions":
              return access?.add_patient === "T" ? (
                <CustomCell {...props} />
              ) : (
                ""
              );
            default:
              return null;
          }
        },
      },
    }}
    dispatch={dispatch}
  />
</div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(PatientList)
);